const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api/v1';
const API_KEY = process.env.REACT_APP_API_KEY || 'wmkTechAPIkey786';

export const fetchHomeData = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/home`, {
            method: 'GET',
            headers: {
                'X-API-KEY': API_KEY,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Failed to fetch home data:', error);
        return null;
    }
};

export const fetchProducts = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/products`, {
            method: 'GET',
            headers: {
                'X-API-KEY': API_KEY,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Failed to fetch products:', error);
        return null;
    }
};

export const fetchServices = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/services`, {
            method: 'GET',
            headers: {
                'X-API-KEY': API_KEY,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Failed to fetch services:', error);
        return null;
    }
};

export const fetchClients = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/clients`, {
            method: 'GET',
            headers: {
                'X-API-KEY': API_KEY,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Failed to fetch clients:', error);
        return null;
    }
};

export const fetchWorks = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/works`, {
            method: 'GET',
            headers: {
                'X-API-KEY': API_KEY,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Failed to fetch works:', error);
        return null;
    }
};

export const fetchBlogs = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/blogs`, {
            method: 'GET',
            headers: {
                'X-API-KEY': API_KEY,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Failed to fetch blogs:', error);
        return null;
    }
};

export const fetchBlogBySlug = async (slug) => {
    try {
        const response = await fetch(`${API_BASE_URL}/blogs/${slug}`, {
            method: 'GET',
            headers: {
                'X-API-KEY': API_KEY,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error(`Failed to fetch blog with slug ${slug}:`, error);
        return null;
    }
};

export const fetchJobs = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/jobs`, {
            method: 'GET',
            headers: {
                'X-API-KEY': API_KEY,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
        }

        const result = await response.json();
        console.log(result);
        return result;
    } catch (error) {
        console.error('Failed to fetch jobs:', error);
        return null;
    }
};

export const fetchFooterData = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/get_footer_data`, {
            method: 'GET',
            headers: {
                'X-API-KEY': API_KEY,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Failed to fetch footer data:', error);
        return null;
    }
};
export const sendInquiry = async (data) => {
    try {
        const isFormData = data instanceof FormData;
        const headers = {
            'X-API-KEY': API_KEY,
            'Accept': 'application/json',
        };

        if (!isFormData) {
            headers['Content-Type'] = 'application/json';
        }

        const response = await fetch(`${API_BASE_URL}/send-inquiry`, {
            method: 'POST',
            headers: headers,
            body: isFormData ? data : JSON.stringify(data),
        });

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Failed to send inquiry:', error);
        return { status: false, message: 'Failed to send inquiry. Please try again later.' };
    }
};

export const applyForJob = async (data) => {
    try {
        const response = await fetch(`${API_BASE_URL}/apply_for_job`, {
            method: 'POST',
            headers: {
                'X-API-KEY': API_KEY,
                'Accept': 'application/json',
            },
            body: data, // FormData
        });

        if (!response.ok) {
            const errorData = await response.json();
            console.error('Validation Error:', errorData);
            return {
                status: false,
                message: errorData.message || 'Validation failed.',
                errors: errorData.errors
            };
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Failed to apply for job:', error);
        return { status: false, message: 'Failed to submit application. Please try again later.' };
    }
};

export const sendContact = async (data) => {
    try {
        const response = await fetch(`${API_BASE_URL}/contact-us`, {
            method: 'POST',
            headers: {
                'X-API-KEY': API_KEY,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Failed to send contact message:', error);
        return { status: false, message: 'Failed to send message. Please try again later.' };
    }
};

export const getItemsCategories = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/items-category`, {
            method: 'GET',
            headers: {
                'X-API-KEY': API_KEY,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Failed to fetch item categories:', error);
        return null;
    }
};


export const getItems = async (slug) => {
    try {
        const response = await fetch(`${API_BASE_URL}/items/${slug}`, {
            method: 'GET',
            headers: {
                'X-API-KEY': API_KEY,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Failed to fetch item categories:', error);
        return null;
    }
};

export const registerUser = async (data) => {
    try {
        const response = await fetch(`${API_BASE_URL}/user-registraton`, {
            method: 'POST',
            headers: {
                'X-API-KEY': API_KEY,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                first_name: data.firstName,
                last_name: data.lastName,
                email: data.email,
                phone: data.phone,
                password: data.password,
                password_confirmation: data.confirmPassword
            }),
        });

        const result = await response.json();

        if (!response.ok) {
            // Handle validation errors from backend
            return {
                status: false,
                message: result.message || 'Registration failed. Please try again.',
                errors: result.errors || {}
            };
        }

        return result;
    } catch (error) {
        console.error('Failed to register user:', error);
        return {
            status: false,
            message: 'Failed to register. Please try again later.',
            errors: {}
        };
    }
};


export const loginUser = async (data) => {
    try {
        const response = await fetch(`${API_BASE_URL}/user-login`, {
            method: 'POST',
            headers: {
                'X-API-KEY': API_KEY,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: data.email,
                password: data.password
            }),
        });

        const result = await response.json();

        if (!response.ok) {
            // Handle validation errors from backend
            return {
                status: false,
                message: result.message || 'Login failed. Please try again.',
                errors: result.errors || {}
            };
        }

        return result;
    } catch (error) {
        console.error('Failed to login user:', error);
        return {
            status: false,
            message: 'Failed to login. Please try again later.',
            errors: {}
        };
    }
};

export const logoutUser = async (token) => {
    try {
        const response = await fetch(`${API_BASE_URL}/logout`, {
            method: 'POST',
            headers: {
                'X-API-KEY': API_KEY,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        });

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Failed to logout user:', error);
        return {
            status: false,
            message: 'Failed to logout. Please try again later.'
        };
    }
};




export const updateUserProfile = async (data, token) => {
    try {
        const response = await fetch(`${API_BASE_URL}/update-user-profile`, {
            method: 'POST',
            headers: {
                'X-API-KEY': API_KEY,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                first_name: data.firstName,
                last_name: data.lastName,
                email: data.email,
                phone: data.phone,
                address: data.address,
                zipcode: data.zipcode,
                city: data.city,
                state: data.state,
                country: data.country
            }),
        });

        const result = await response.json();

        if (!response.ok) {
            return {
                status: false,
                message: result.message || 'Profile update failed. Please try again.',
                errors: result.errors || {}
            };
        }

        return result;
    } catch (error) {
        console.error('Failed to update profile:', error);
        return {
            status: false,
            message: 'Failed to update profile. Please try again later.',
            errors: {}
        };
    }
};

export const getUserProfile = async (token) => {
    try {
        const response = await fetch(`${API_BASE_URL}/get-user-profile`, {
            method: 'GET',
            headers: {
                'X-API-KEY': API_KEY,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Failed to fetch user profile:', error);
        return null;
    }
};


export const changePassword = async (data, token) => {
    try {
        const response = await fetch(`${API_BASE_URL}/change-password`, {
            method: 'POST',
            headers: {
                'X-API-KEY': API_KEY,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                current_password: data.currentPassword,
                new_password: data.newPassword,
                new_password_confirmation: data.confirmPassword
            }),
        });

        const result = await response.json();

        if (!response.ok) {
            return {
                status: false,
                message: result.message || 'Password change failed. Please try again.',
                errors: result.errors || {}
            };
        }

        return result;
    } catch (error) {
        console.error('Failed to change password:', error);
        return {
            status: false,
            message: 'Failed to change password. Please try again later.',
            errors: {}
        };
    }
};
export const addToCart = async (data, token) => {
    try {
        const response = await fetch(`${API_BASE_URL}/cart/add`, {
            method: 'POST',
            headers: {
                'X-API-KEY': API_KEY,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                product_id: data.itemId,
                quantity: data.quantity || 1
            }),
        });

        const result = await response.json();

        if (!response.ok) {
            return {
                status: false,
                message: result.message || 'Failed to add item to cart.',
                errors: result.errors || {}
            };
        }

        return result;
    } catch (error) {
        console.error('Failed to add to cart:', error);
        return {
            status: false,
            message: 'Failed to add to cart. Please try again later.',
            errors: {}
        };
    }
};

export const getItemDetails = async (id) => {
    try {
        const response = await fetch(`${API_BASE_URL}/item-details/${id}`, {
            method: 'GET',
            headers: {
                'X-API-KEY': API_KEY,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Failed to fetch item details:', error);
        return null;
    }
};

export const getCart = async (token) => {
    try {
        const response = await fetch(`${API_BASE_URL}/cart`, {
            method: 'GET',
            headers: {
                'X-API-KEY': API_KEY,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Failed to fetch cart:', error);
        return null;
    }
};

export const updateCart = async (data, token) => {
    try {
        console.log('UpdateCart called with:', data); // Debug log

        const response = await fetch(`${API_BASE_URL}/cart/update`, {
            method: 'POST',
            headers: {
                'X-API-KEY': API_KEY,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                product_id: data.productId,
                quantity: data.quantity
            }),
        });

        const result = await response.json();
        console.log('UpdateCart response:', result); // Debug log
        return result;
    } catch (error) {
        console.error('Failed to update cart:', error);
        return { status: false, message: 'Failed to update cart.' };
    }
};

export const removeFromCart = async (cartItemId, token) => {
    try {
        const response = await fetch(`${API_BASE_URL}/cart/remove/${cartItemId}`, {
            method: 'DELETE',
            headers: {
                'X-API-KEY': API_KEY,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        });

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Failed to remove from cart:', error);
        return { status: false, message: 'Failed to remove item from cart.' };
    }
};


export const checkout = async (token) => {
    try {
        const response = await fetch(`${API_BASE_URL}/checkout`, {
            method: 'GET',
            headers: {
                'X-API-KEY': API_KEY,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Failed to fetch checkout data:', error);
        return null;
    }
};

export const placeOrder = async (data, token) => {
    try {
        const response = await fetch(`${API_BASE_URL}/checkout/place-order`, {
            method: 'POST',
            headers: {
                'X-API-KEY': API_KEY,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(data),
        });

        const result = await response.json();

        if (!response.ok) {
            return {
                status: false,
                message: result.message || 'Order failed. Please try again.',
                errors: result.errors || {}
            };
        }

        return result;
    } catch (error) {
        console.error('Failed to place order:', error);
        return {
            status: false,
            message: 'Failed to place order. Please try again later.',
            errors: {}
        };
    }
};

export const fetchOrders = async (token) => {
    try {
        const response = await fetch(`${API_BASE_URL}/orders`, {
            method: 'GET',
            headers: {
                'X-API-KEY': API_KEY,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        });

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Failed to fetch orders:', error);
        return { status: false, message: 'Failed to fetch orders' };
    }
};

export const fetchOrderDetails = async (id, token) => {
    try {
        const response = await fetch(`${API_BASE_URL}/orders/${id}`, {
            method: 'GET',
            headers: {
                'X-API-KEY': API_KEY,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        });

        const result = await response.json();
        return result;
    } catch (error) {
        console.error(`Failed to fetch order details for ${id}:`, error);
        return { status: false, message: 'Failed to fetch order details' };
    }
};

export const fetchCountries = async (token) => {
  try {
    const headers = {
      'X-API-KEY': API_KEY,
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    };

    // Add Authorization header if token is provided
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(`${API_BASE_URL}/get-country-list`, {
      method: 'GET',
      headers: headers,
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status} ${response.statusText}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Failed to fetch countries:', error);
    return null;
  }
};

export const fetchStates = async (countryId, token) => {
  try {
    const headers = {
      'X-API-KEY': API_KEY,
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    };

    // Add Authorization header if token is provided
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(`${API_BASE_URL}/get-state-list/${countryId}`, {
      method: 'GET',
      headers: headers,
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status} ${response.statusText}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error(`Failed to fetch states for country ${countryId}:`, error);
    return null;
  }
};